import { getElementById } from "./Utils";
import { any } from "./Reductions";

const ToggleNames = [
  "DELETE_ME",
  "HEUREKA_1913_MIGRATE_TO_OC_SHEET",
  "HEUREKA_1975_OC_CHIP_MIGRATION",
  "HEUREKA_2220_MIGRATE_TO_OC_TEXT_FIELD",
  "HEUREKA_2276_STATELESS_TRACKING_CHANGE",
  "HEUREKA_2276_STATELESS_TRACKING_SUBMIT",
  "HEUREKA_2288_LAZY_FILTER_LOADING",
] as const;

export type ToggleName = (typeof ToggleNames)[number];
export type ToggleStates = Record<ToggleName, boolean>;

let toggles: ToggleStates;

function asBoolean(value?: string): boolean {
  return "true" === value;
}

export function initToggles() {
  const data = getElementById("leafcutter_toggles")?.dataset;
  const state = data
    ? (toggleName: ToggleName) => asBoolean(data[toggleName] || data[toggleName.toLowerCase()])
    : () => false;
  toggles = ToggleNames.reduce((htmlToggles, toggleName) => {
    htmlToggles[toggleName] = state(toggleName);
    return htmlToggles;
  }, {} as Partial<ToggleStates>) as ToggleStates;
}

/**
 *
 */
export function updateToggle(toggle: ToggleName, state: boolean) {
  if (!toggles) {
    toggles = {} as ToggleStates;
  }
  toggles[toggle] = state;
}

export function isNotActive(toggle: ToggleName) {
  return !isActive(toggle);
}

export function isActive(toggle: ToggleName) {
  return toggles[toggle];
}

export function isAnyActive(...toggles: ToggleName[]) {
  return toggles.map(isActive).reduce(any, false);
}
